import React from "react";
import FooterMainBundle from "./FooterMainBundle";

const FooterMainContainerBundle = React.memo(({...props }) => {
  return <FooterMainBundle {...props } />;
});

export default FooterMainContainerBundle;
